<template>
  <v-container fluid class="bg-red-gradient" fill-height>
    <v-row align="center" justify="center" class="mx-auto">
      <v-col cols="12" sm="12" md="6" lg="6" xl="6">
        <v-card :loading="loginLoader" class="mx-auto" elevation="24" :max-width="this.$vuetify.breakpoint.width <= 600 ? '100%' : '80%'">
          <v-toolbar src="./../../assets/img-png/bg-videos.webp" :color="constants.primaryColor" prominent dark flat>
            <v-toolbar-title class="title font-weight-light text-center">{{ selectedLanguage.lgWelcome }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon target="_blank">
              <v-icon>fas fa-user</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pb-0">
            <v-form ref="loginForm" class="mx-auto mt-4" valid="valid" style="width: 20em;">
              <v-text-field
                :label="selectedLanguage.lgUser"
                name="login"
                outlined
                rounded
                flat
                :rules="usernameRules"
                @keypress.enter="login()"
                v-model="username"
                :color="constants.primaryColor"
                append-icon="mdi-account"
                type="text"
              ></v-text-field>

              <v-text-field
                id="password"
                :label="selectedLanguage.lgPass"
                v-model="password"
                outlined
                rounded
                flat
                :rules="passwordRules"
                name="password"
                @keypress.enter="login()"
                :color="constants.primaryColor"
                append-icon="mdi-lock"
                type="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="mt-0 pt-0">
            <v-spacer></v-spacer>
            <v-btn
              dark
              rounded
              :color="constants.primaryColor"
              depressed
              class="mb-4 white--text pa-4"
              @click="login()"
              >{{ selectedLanguage.lgLogin }}
              <v-icon right small>fas fa-arrow-circle-right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  data: () => ({
    images: {},
    username: "",
    password: "",
    valid: true,
    usernameRules: [],
    passwordRules: [],
  }),
  created() {
    this.loadDarkMode();
    this.assignRules();
  },
  methods: {
    loadDarkMode() {
      if (localStorage.getItem("darkMode")) {
        this.darkMode =
          localStorage.getItem("darkMode") == "true" ? true : false;
        this.$vuetify.theme.dark = this.darkMode;
      }
    },
    login() {
      if (!this.$refs.loginForm.validate()) {
        return false;
      }

      this.promptParent({
        action: "userModule/login",
        credentials: {
          username: this.username,
          password: this.password,
        },
      });
    },
    assignRules() {
      this.usernameRules = [(v) => !!v || this.selectedLanguage.lgUserRequired];
      this.passwordRules = [(v) => !!v || this.selectedLanguage.lgPassRequired];
    },
    promptParent(action) {
      this.$emit("prompt", action);
    },
  },
  computed: {
    selectedLanguage() {
      return this.$store.state.langs.language;
    },
    constants() {
      return this.$store.state.constantsModule;
    },
    loginLoader() {
      return this.$store.state.UI.loaders.loginLoader;
    }
  },
};
</script>

<style>
  .bg-red-gradient {
    background: #333333;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #000, #310505, #000);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,#000, #310505, #000); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  }
</style>
